var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.997 16C6.46601 16.012 -0.00899063 9.46 9.3707e-06 1.003C9.3707e-06 0.45 0.448009 0 1.00001 0H3.64001C4.13501 0 4.55601 0.364 4.62901 0.854C4.80311 2.02905 5.14493 3.17305 5.64401 4.251L5.74701 4.473C5.8162 4.62239 5.83108 4.79124 5.78909 4.95043C5.7471 5.10962 5.65088 5.24917 5.51701 5.345C4.69901 5.929 4.38701 7.104 5.02401 8.02C5.82599 9.17333 6.82695 10.1746 7.98001 10.977C8.89701 11.613 10.072 11.301 10.655 10.484C10.7507 10.3497 10.8904 10.2531 11.0498 10.211C11.2092 10.1688 11.3784 10.1836 11.528 10.253L11.749 10.355C12.827 10.855 13.971 11.197 15.146 11.371C15.636 11.444 16 11.865 16 12.361V15C16 15.1314 15.9741 15.2615 15.9238 15.3829C15.8735 15.5043 15.7997 15.6146 15.7068 15.7075C15.6138 15.8003 15.5034 15.874 15.382 15.9242C15.2606 15.9744 15.1304 16.0001 14.999 16H14.997Z",
    fill: "#505762"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneFill);
export default __webpack_public_path__ + "static/media/phone-fill.1e584e5912978037a9f1fb824f5718aa.svg";
export { ForwardRef as ReactComponent };